import { render, staticRenderFns } from "./DdsFinalize.vue?vue&type=template&id=d30794e2&"
import script from "./DdsFinalize.vue?vue&type=script&lang=js&"
export * from "./DdsFinalize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports